import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BaseApiResponse } from '@/types/api/api-v2';
import { SkuDTO } from '@/types/api/sku';

export default async function getReleaseCalendar(): Promise<SkuDTO[]> {
  try {
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<SkuDTO[]>>('/sku/release-calendar');
    return data;
  } catch (e: unknown) {
    console.error(e);
    throw new Error('Failed to fetch release calendar');
  }
}
